import { generateClient } from 'aws-amplify/api';

const deleteAccountMutation = /* GraphQL */ `
  mutation DeleteAccount {
    deleteUserAccount {
      cognito_sub
      message
      success
    }
  }
`;

export async function deleteAccount() {
  const client = generateClient();
  const result = await client.graphql({
    query: deleteAccountMutation,
    authMode: "userPool",
  });

  const payload = result.data?.deleteUserAccount;

  if (!payload) {
    throw new Error(result?.errors?.[0]?.message || "Empty deleteAccount response.");
  }

  if (!payload.success) {
    throw new Error(payload.message || "Delete account request failed.");
  }

  return payload;
}